import React from 'react';
import { PAYMENT_BASE_URL } from '@/config/urls';
import Index from '@/pages/Index';
import PaymentDomainLanding from '@/pages/PaymentDomainLanding';

const PaymentDomainRouter: React.FC = () => {
  const isPaymentDomain = 
    window.location.hostname === new URL(PAYMENT_BASE_URL).hostname
  
  // For localhost development, allow both landing pages
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  
  // In localhost, show the normal landing page (for easier development)
  if (isLocalhost) {
    return <Index />;
  }
  
  // In billpa.id, show the payment domain landing page
  if (isPaymentDomain) {
    return <PaymentDomainLanding />;
  }

  // In any other domain (keepmore.co), show the normal landing page
  return <Index />;
};

export default PaymentDomainRouter;
